import { useAppSelector } from 'app/hooks';

import type { TTSShopPermissionsType } from 'model/types/permissions';

export default function useTTSShopPermissions(): TTSShopPermissionsType {
  const merchant = useAppSelector((store) => store.merchant.merchant);

  const isMerchantNull = merchant == null;

  // An empty url is not an actionable destination — `open('', '_self')` just reloads the current
  // document — so it counts as absent, and every consumer reads that single normalized value.
  const shopAuthUrl = merchant?.tiktokShopAuthUrl || null;
  const hasTiktokShopFeature = merchant?.features?.includes('TIKTOK_SHOP') ?? false;

  const handleGrantTTSShopPermissions = () => {
    if (shopAuthUrl) globalThis.open(shopAuthUrl, '_self');
  };

  return { isMerchantNull, shopAuthUrl, hasTiktokShopFeature, handleGrantTTSShopPermissions };
}
